export const dealPriceFrom = (deal, isTakeAway) => {
  if (!deal) return 0;

  if (!deal.pricesFrom) return deal.priceFrom;

  return isTakeAway ? deal.pricesFrom.price : deal.pricesFrom.priceEatIn;
};
